// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pagination-module__paginationContainer___VYI_v {
  display: flex;
  align-items: center;
  gap: 24px;
}

.Pagination-module__pageCountSelect___vzkCg {
  position: relative;
  display: inline-block;
}

.Pagination-module__pageCountSelect___vzkCg select {
  background: #fff;
  width: 61px;
  height: 32px;
  font-size: 14px;
  font-weight: 500;
  opacity: 1;
  border: none;
  border-radius: 5px;
  padding: 0px 14px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  color: #263643;
  box-shadow: 0px 0px 5px 0px #a1a1a140;
  cursor: pointer;
}

.Pagination-module__pageCountSelect___vzkCg select:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.Pagination-module__pageCountSelect___vzkCg select > option {
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  text-transform: capitalize;
}

.Pagination-module__arrowDownIcon___rDS7Q {
  width: 9px;
  height: 9px;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.Pagination-module__pagination___mfFiE {
  display: flex;
  align-items: center;
  gap: 8px;
}

.Pagination-module__paginationButton___YbMns {
  width: 32px;
  height: 32px;
  border: none;
  background-color: #e5e9ec;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.Pagination-module__paginationButton___YbMns:hover:not(:disabled) {
  background-color: #d0d5da;
}

.Pagination-module__paginationButton___YbMns:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.Pagination-module__paginationButton___YbMns img {
  width: 13px;
  height: 13px;
}

.Pagination-module__paginationPageNumber___HS8zm {
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  vertical-align: middle;
  text-transform: uppercase;
  color: #556575;
  cursor: pointer;
  transition: color 0.2s ease;
}

.Pagination-module__paginationPageNumber___HS8zm:hover {
  color: #263643;
}

.Pagination-module__paginationPageNumber___HS8zm.Pagination-module__active___liOGt {
  color: #000000;
  cursor: pointer;
}

.Pagination-module__paginationEllipsis___TrLK8 {
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  vertical-align: middle;
  color: #556575;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/pagination/Pagination.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,cAAc;EACd,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB","sourcesContent":[".paginationContainer {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.pageCountSelect {\n  position: relative;\n  display: inline-block;\n}\n\n.pageCountSelect select {\n  background: #fff;\n  width: 61px;\n  height: 32px;\n  font-size: 14px;\n  font-weight: 500;\n  opacity: 1;\n  border: none;\n  border-radius: 5px;\n  padding: 0px 14px;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  color: #263643;\n  box-shadow: 0px 0px 5px 0px #a1a1a140;\n  cursor: pointer;\n}\n\n.pageCountSelect select:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.pageCountSelect select > option {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 100%;\n  text-transform: capitalize;\n}\n\n.arrowDownIcon {\n  width: 9px;\n  height: 9px;\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n.pagination {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.paginationButton {\n  width: 32px;\n  height: 32px;\n  border: none;\n  background-color: #e5e9ec;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s ease;\n}\n\n.paginationButton:hover:not(:disabled) {\n  background-color: #d0d5da;\n}\n\n.paginationButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.paginationButton img {\n  width: 13px;\n  height: 13px;\n}\n\n.paginationPageNumber {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n  vertical-align: middle;\n  text-transform: uppercase;\n  color: #556575;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.paginationPageNumber:hover {\n  color: #263643;\n}\n\n.paginationPageNumber.active {\n  color: #000000;\n  cursor: pointer;\n}\n\n.paginationEllipsis {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n  vertical-align: middle;\n  color: #556575;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paginationContainer": `Pagination-module__paginationContainer___VYI_v`,
	"pageCountSelect": `Pagination-module__pageCountSelect___vzkCg`,
	"arrowDownIcon": `Pagination-module__arrowDownIcon___rDS7Q`,
	"pagination": `Pagination-module__pagination___mfFiE`,
	"paginationButton": `Pagination-module__paginationButton___YbMns`,
	"paginationPageNumber": `Pagination-module__paginationPageNumber___HS8zm`,
	"active": `Pagination-module__active___liOGt`,
	"paginationEllipsis": `Pagination-module__paginationEllipsis___TrLK8`
};
export default ___CSS_LOADER_EXPORT___;
